<div class="drop-container">
  @if (!isInputTextControl) {
  <input type="text" [class]="isInputTextControl ? 'sat-input-control-primary' :
             (isTransparent ? 'dropdown-input-transparent' : 'dropdown-input')" #dropInput [placeholder]="placeholder"
    [matAutocomplete]="auto" (input)="filterOptions(dropInput.value)" [readOnly]="isNotEditable"
    (keyup)="onClickKeyUp($event)" (focus)="isNotEditable && openFocus()" (click)="isNotEditable && openFocus()"
    (blur)="checkValid()" />
  @if (!isInputTextControl && !isNotEditable) {
  <span class="dropdown-img" (click)="openFocus()"></span>
  }
  @if (showError && isError) {
  <div class="text-error">
    {{ errorMessage }}
  </div>
  }
  } @else {
  <input type="text" [class]="isInputTextControl ? 'sat-input-control-primary' : 'dropdown-input'"
    [placeholder]="placeholder" [matAutocomplete]="auto" [formControl]="getFormControl()" [readOnly]="isNotEditable"
    (keyup)="onClickKeyUp($event)" (focus)="isNotEditable && openFocus()" (click)="isNotEditable && openFocus()" />
  }
</div>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event)">
  @if (!isInputTextControl) {
  @for (option of filteredOptions; track option.id) {
  <mat-option [value]="option.title">
    <div style="display: flex; flex-direction: column;" (click)="onClick(option.id)">
      <span class="title-text">{{ option.title }}</span>
      @if (option.extra) {
      <span class="extra-text">{{ option.extra }}</span>
      }
    </div>
  </mat-option>
  }
  } @else {
  @for (option of options; track option.id) {
  <mat-option [value]="option.title">
    <div style="display: flex; flex-direction: column" (click)="onClick(option.id)">
      <span class="title-text">{{ option.title }}</span>
      @if (option.extra) {
      <span class="extra-text">{{ option.extra }}</span>
      }
    </div>
  </mat-option>
  }
  }
</mat-autocomplete>